import { Routes } from '@angular/router';

/**
 * Handle chunk load errors (e.g. after a new deployment when cached chunk names are stale).
 * Forces a hard navigation with cache-busting URL so Chrome mobile doesn't reuse cache.
 */
function handleChunkError(err: any): never {
  const chunkFailedMessage = /Loading chunk|Failed to fetch dynamically imported module|error loading dynamically imported module/i;
  if (chunkFailedMessage.test(err?.message)) {
    // Prevent infinite reload loop (10s cooldown)
    const key = '__chunk_reload';
    const lastReload = sessionStorage.getItem(key);
    const now = Date.now();
    if (!lastReload || now - parseInt(lastReload, 10) > 10000) {
      sessionStorage.setItem(key, now.toString());
      // Cache-busting: navigate to same URL with a version param to bypass all caches
      const url = new URL(window.location.href);
      url.searchParams.set('_v', now.toString());
      window.location.href = url.toString();
    }
  }
  throw err;
}

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./layout/main-layout/main-layout')
      .then(m => m.MainLayout)
      .catch(handleChunkError),
    children: [
      { path: '', redirectTo: 'home', pathMatch: 'full' },
      {
        path: '',
        loadChildren: () => import('./features/music/music.routes')
          .then(m => m.MUSIC_ROUTES)
          .catch(handleChunkError)
      },
      {
        path: 'shop',
        loadChildren: () => import('./features/shop/shop.routes')
          .then(m => m.SHOP_ROUTES)
          .catch(handleChunkError)
      },
    ]
  },

  {
    // Hors du layout principal : ouvert depuis un email par quelqu'un qui n'a
    // pas forcement de compte, donc sans garde d'authentification.
    path: 'ticket/:token',
    loadComponent: () => import('./features/music/pages/ticket-access/ticket-access')
      .then(m => m.TicketAccess_Page)
      .catch(handleChunkError),
    title: 'Mon billet - Colorfol'
  },
  {
    path: 'cookies',
    loadComponent: () => import('./features/legal/pages/cookies/cookies')
      .then(m => m.CookiesPage)
      .catch(handleChunkError),
    title: 'Politique relative aux cookies - Colorfol'
  },

  {
    path: 'auth',
    loadChildren: () => import('./features/auth/auth.routes')
      .then(m => m.AUTH_ROUTES)
      .catch(handleChunkError)
  }
];
